import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../shared/page-layout/page-data-panel.component';

@Component({
    selector: 'app-expense-approval-workflow',
    standalone: true,
    templateUrl: './expense-approval-workflow.component.html',
    styleUrl: './expense-approval-workflow.component.css',
    imports: [CommonModule, RouterModule, ButtonModule, TagModule, PageDataPanelComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpenseApprovalWorkflowComponent {
    readonly workflowEngineParams = { resourceKey: 'EXPENSE' };
}
